import { MaterialCiqIcon } from "components/svg-icons";
import BulkFeatureEditStatus from "components/bulk-edit-status/bulk-feature-edit-status";
import type { WorkflowItem } from "components/bulk-edit-status/types";

interface BulkFeatureEditMaterialStatusProps {
  onUpdateDone: () => void;
  selectedRows: any[];
  showEdit: boolean;
  setShowEdit: (v: any) => void;
  // accepted for backward-compat with the header wiring; unused
  // eslint-disable-next-line react/no-unused-prop-types
  onCancelClick?: () => void;
}

/**
 * Material-specific thin wrapper over the shared `BulkFeatureEditStatus`.
 * Material grid rows already carry the flattened WorkflowItem fields, so the
 * adapter is the identity function. All status logic lives in the shared
 * component (single source of truth); this only supplies material labels,
 * icon and the predecessor-exclusion behavior.
 */
function BulkFeatureEditMaterialStatus(
  props: BulkFeatureEditMaterialStatusProps
) {
  const { onUpdateDone, selectedRows, showEdit, setShowEdit } = props;

  return (
    <BulkFeatureEditStatus
      selectedRows={selectedRows}
      mapRowToWorkflowItem={(row: any): WorkflowItem => row}
      entityLabelSingular="Material"
      entityLabelPlural="Materials"
      icon={
        <MaterialCiqIcon
          size={20}
          className="fill-ciq-gray-900 pr-[5px]"
          opacity="1"
        />
      }
      enablePredecessorExclusion
      testIdPrefix="bulkfeatureeditmaterialstatus"
      showEdit={showEdit}
      setShowEdit={setShowEdit}
      onUpdateDone={onUpdateDone}
    />
  );
}

export default BulkFeatureEditMaterialStatus;
